import { render, staticRenderFns } from "./footerVue.vue?vue&type=template&id=27d5fa6e&"
import script from "./footerVue.vue?vue&type=script&lang=js&"
export * from "./footerVue.vue?vue&type=script&lang=js&"
import style0 from "./footerVue.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports